import antdZhCN from 'ant-design-vue/es/locale-provider/zh_CN';
import momentCN from 'moment/locale/zh-cn';

import menu from './menu';
import workplace from './workplace';

import systemAdmin from './system/admin';

const components = {
  antLocale: antdZhCN,
  momentName: 'zh',
  momentLocale: momentCN
}

export default {
  message: '-',

  ...components,
  ...menu,
  ...workplace,
  ...systemAdmin
}